export function resetPageScroll(anchor?:HTMLElement|null){
  const containers=new Set<HTMLElement>();
  document.querySelectorAll<HTMLElement>('[data-page-scroll]').forEach(el=>containers.add(el));
  for(let el=anchor;el;el=el.parentElement)containers.add(el);
  containers.add(document.documentElement);containers.add(document.body);
  containers.forEach(el=>{const previous=el.style.scrollBehavior;el.style.scrollBehavior='auto';el.scrollTop=0;el.scrollLeft=0;el.style.scrollBehavior=previous;});
  window.scrollTo({top:0,left:0,behavior:'auto'});
}
